import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { abouts } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
import "./Work.scss";
import { Link } from "react-router-dom";

const Work = () => {
  const [selectedCategory, setSelectedCategory] = useState("AWS-DevOps");
  const [filteredAbouts, setFilteredAbouts] = useState([]);

  useEffect(() => {
    setFilteredAbouts(
      abouts.filter((item) => item.category === selectedCategory)
    );
  }, [selectedCategory]);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  return (
    <>
      <h2 className="head-text">
        My Creative <span>Portfolio</span>
        <br />
        Section
      </h2>
      <div className="category-buttons">
        <button onClick={() => handleCategoryClick("AWS-DevOps")}>
          AWS-DevOps
        </button>
        <button onClick={() => handleCategoryClick("Full-Stack")}>
          Full Stack
        </button>
        <button onClick={() => handleCategoryClick("UI/UX")}>UI/UX</button>
      </div>
      <div className="app__profiles">
        {filteredAbouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="app__profile-item"
            key={about.title + index}
          >
            <Link to={`/${about.id}`}>
              {" "}
              <img src={about.imgUrl} alt={about.title} />
            </Link>
            <h2 className="bold-text" style={{ marginTop: 20 }}>
              {about.title}
            </h2>
            {/* Assuming you want to display the category */}
            <p className="p-text" style={{ marginTop: 10 }}>
              {about.tec}
            </p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg"
);

// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { abouts } from "../../constants";
// import { AppWrap, MotionWrap } from "../../wrapper";
// import "./Work.scss";
// import { Link } from "react-router-dom";

// const Work = () => {
//   const [selectedCategory, setSelectedCategory] = useState("All");

//   const handleCategoryClick = (category) => {
//     setSelectedCategory(category);
//   };

//   const filteredAbouts =
//     selectedCategory === "All"
//       ? abouts
//       : abouts.filter((item) => item.category === selectedCategory);

//   return (
//     <>
//       <h2 className="head-text">
//         My Creative <span>Portfolio</span>
//         <br />
//         Section
//       </h2>
//       <div className="category-buttons">
//         <button onClick={() => handleCategoryClick("All")}>All</button>
//         <button onClick={() => handleCategoryClick("Full-Stack")}>
//           Full Stack
//         </button>
//         <button onClick={() => handleCategoryClick("AWS-DevOps")}>
//           AWS-DevOps
//         </button>
//         <button onClick={() => handleCategoryClick("UI/UX")}>UI/UX</button>
//       </div>
//       <div className="app__profiles">
//         {filteredAbouts.map((about, index) => (
//           <motion.div
//             whileInView={{ opacity: 1 }}
//             whileHover={{ scale: 1.1 }}
//             transition={{ duration: 0.5, type: "tween" }}
//             className="app__profile-item"
//             key={about.title + index}
//           >
//             <Link to={`/${about.id}`}>
//               {" "}
//               <img src={about.imgUrl} alt={about.title} />
//             </Link>
//             <h2 className="bold-text" style={{ marginTop: 20 }}>
//               {about.title}
//             </h2>
//             {/* Assuming you want to display the category */}
//             <p className="p-text" style={{ marginTop: 10 }}>
//               {about.tec}
//             </p>
//           </motion.div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default AppWrap(
//   MotionWrap(Work, "app__works"),
//   "work",
//   "app__primarybg"
// );
